import React from 'react';

// Profile data - hardcoded
const profileData = {
  name: "David Antúnez",
  profileImage: "https://customer-assets.emergentagent.com/job_frame-studio-19/artifacts/6r3mkxxf_image.png",
  bio: `Soy David Antúnez, creativo audiovisual, cineasta y fotógrafo. Me dedico a la cinematografía, edición, corrección de color y fotografía, transformando ideas en proyectos visuales claros y coherentes.

Trabajo en documentales, videoclips musicales, producciones comerciales y proyectos artísticos, combinando técnica y narrativa para que cada historia tenga su propio lenguaje visual. Me interesa cuidar los detalles en cada proyecto y adaptar los recursos técnicos y creativos a las necesidades de cada historia, buscando siempre que el resultado sea efectivo y consistente.`
};

const About = () => {
  return (
    <section id="about" className="about-section py-32 px-6 relative overflow-hidden">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: `url(${profileData.profileImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed'
        }}
      >
        <div className="absolute inset-0 bg-black/85"></div>
      </div>

      <div className="max-w-6xl mx-auto relative z-10">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Profile Image */}
          <div className="about-image-wrapper">
            <div className="relative overflow-hidden rounded-lg shadow-2xl">
              <img 
                src={profileData.profileImage}
                alt={profileData.name}
                className="w-full h-auto object-cover transition-transform duration-700 hover:scale-105"
              />
            </div>
          </div>

          {/* Bio Content */}
          <div className="about-content">
            <h2 className="text-5xl md:text-6xl font-bold text-white mb-6">
              Sobre Mí
            </h2>
            <div className="h-1 w-24 bg-white mb-8"></div>
            <p className="text-lg text-gray-300 leading-relaxed mb-6 whitespace-pre-line">
              {profileData.bio}
            </p>
            <div className="flex flex-wrap gap-3 mt-8">
              <span className="px-4 py-2 bg-white/10 backdrop-blur-sm text-white rounded-full text-sm">
                Cinematografía
              </span>
              <span className="px-4 py-2 bg-white/10 backdrop-blur-sm text-white rounded-full text-sm">
                Dirección
              </span>
              <span className="px-4 py-2 bg-white/10 backdrop-blur-sm text-white rounded-full text-sm">
                Edición
              </span>
              <span className="px-4 py-2 bg-white/10 backdrop-blur-sm text-white rounded-full text-sm">
                Corrección de Color
              </span>
              <span className="px-4 py-2 bg-white/10 backdrop-blur-sm text-white rounded-full text-sm">
                Fotografía
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
